import { useDispatch, useSelector } from "react-redux";
import {
  addCircular,
  deleteCircular,
  getAllCircular,
  getTargetAudience,
  handleAddtionalInfo,
  setActiveCircular,
  setOffset,
  setPage,
  setPerPage,
  setRidirect,
  updateCircular,
  getStudentsById,
  getBatchByDepartmentID,
  getStudentsByBatchYear,
  updateCurrentYear,
  searchStudentForMigration,
} from "../store/circular";

export default function useCircular() {
  const dispatch = useDispatch();

  const circularDate = useSelector((state) => state.circular?.data);
  const targetAudience = useSelector((state) => state.circular?.targetAudience);
  const additionalInfo = useSelector((state) => state.circular?.additionalInfo);
  const redirect = useSelector((state) => state.circular.redirect);
  const activeCircular = useSelector((state) => state.circular?.activeCircular);
  const loading = useSelector((state) => state.circular?.loading);
  const deleteLoading = useSelector((state) => state.circular?.deleteLoading);
  const page = useSelector((state) => state.circular?.page);
  const perPage = useSelector((state) => state.circular?.perPage);
  const offset = useSelector((state) => state.circular?.offset);
  const getStudentsID = useSelector((state) => state.circular?.studentsById);
  const getBatchByDepartment = useSelector((state) => state.circular?.batchByDepartmentID);
  const getStudentsByBatch = useSelector((state) => state.circular?.studentsByBatchYear);
  const updateCurrentYearData = useSelector((state) => state.circular?.updatedCurrentYear);
  const searchStudentForMigrationData = useSelector((state) => state.circular?.searchStudentMigration);

  const getAllCircularAction = (params) => dispatch(getAllCircular(params));
  const addCircularAction = (params) => dispatch(addCircular(params));
  const updateCircularAction = (params) => dispatch(updateCircular(params));
  const handleAddtionalInfoAction = (params) =>
    dispatch(handleAddtionalInfo(params));
  const getTargetAudienceAction = (params) => dispatch(getTargetAudience(params));
  const deleteCircularAction = (params) => dispatch(deleteCircular(params));
  const setActiveCircularAction = (params) =>
    dispatch(setActiveCircular(params));
  const setRidirectAction = () => dispatch(setRidirect());

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  const studentsByIdAction = (parms)=> dispatch(getStudentsById(parms));
  const getBatchByDepartmentIDAction = (parms)=> dispatch(getBatchByDepartmentID(parms));
  const getStudentsByBatchAction = (parms)=> dispatch(getStudentsByBatchYear(parms));
  const updateCurrentYearAction = (parms)=> dispatch(updateCurrentYear(parms));
  const searchStudentForMigrationAction = (parms)=> dispatch(searchStudentForMigration(parms));

  return {
    // data
    targetAudience,
    circularDate,
    additionalInfo,
    activeCircular,
    loading,
    deleteLoading,
    redirect,
    page,
    perPage,
    offset,
    getStudentsID,
    getBatchByDepartment,
    getStudentsByBatch,
    updateCurrentYearData,
    searchStudentForMigrationData,
    // actions
    getTargetAudienceAction,
    getAllCircularAction,
    deleteCircularAction,
    addCircularAction,
    handleAddtionalInfoAction,
    setActiveCircularAction,
    updateCircularAction,
    setRidirectAction,

    setOffsetAction,
    setPerPageAction,
    setPageAction,
    
    studentsByIdAction,
    getBatchByDepartmentIDAction,
    getStudentsByBatchAction,
    updateCurrentYearAction,
    searchStudentForMigrationAction,
  };
}
